<template>
  <div class="vertical-container">
    <div class="vertical-list-wrapper">
      <swiper
        ref="swiper"
        class="vertical-list swiper"
        :options="swiperOption"
      >
        <swiper-slide
          v-for="item in items"
          :key="item.name"
          class="vertical-list__item"
        >
          <a
            class="vertical-list__anchor"
            :class="{ 'vertical-list__anchor--active': currentItem.name === item.name}"
            @click="$emit('click', item)"
          >
            {{ item.name }}
          </a>
        </swiper-slide>
      </swiper>
      <div class="swiper-scrollbar" />
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: 'FilterList',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    currentItem: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      swiperOption: { 
        slidesPerView: 'auto', 
        cssMode: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: false,
        },
        // breakpoints: {
        //   1081: {
        //     slidesPerView: 'auto',
        //     cssMode: true,
        //   },
        // }
      },
    }
  },
  mounted() {
    this.goto(0)
  },
  methods: {
    goto(i) {
      setTimeout(() => {
        this.$refs.swiper.$swiper.slideTo(i)
      }, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.vertical-container {
  position: relative;
}
.vertical-list-wrapper {
  @media only screen and (max-width: 1080px){
    margin: 0 calc(((30 / 720) * 100) * 1vw);
    padding-bottom: 4px;
  }
}
.vertical-list {
  display: flex;
  margin: 30px 0 30px;
  width: 1150px;
  @media only screen and (max-width: 1080px){
    margin-bottom: 0;
    width: 100%;
  }
  &__anchor {
    display: block;
    padding: 8px 22px;
    box-sizing: border-box;
    font-size: 18px;
    color: #333333;
    @media only screen and (max-width: 1080px){
      font-size: 16px;
      padding: 8px 12px;
    }
    &--active {
      border-bottom: solid 3px #fd312e;
      font-weight: 400;
    }
  }
  &__anchor:hover {
    cursor: pointer;
  }
  &__item {
    margin-left: 5px;  
    width: auto;
    display: block;
    @media only screen and (max-width: 1080px){
      // float: left;
    }
  }
  &__item:first-child {
    margin-left: 0;
  }
}
.swiper-scrollbar {
  height: 3px;
  margin-top: -3px;
  // background: rgba(227, 227, 227, 0.935);
  /deep/ .swiper-scrollbar-drag {
    background: rgba(0, 0, 0, 0.2);
  }
}
</style>